import React, {useMemo} from "react";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import LoyaltyRewardsOverview from "@widgets/loyaltyRewards/overview/LoyaltyRewardsOverview";

const LoyaltyRewards = () => {
    const route: Route = useMemo(() => router.loyaltyRewards, []);

    return (
        <AdminLayout currentPage={route}>
            <LoyaltyRewardsOverview route={route}/>
        </AdminLayout>
    );
};

export default LoyaltyRewards;